<template>
  <div>
    <v-tabs ref="tabs" v-model="tab" class="primary-background">
      <v-tab v-for="item in tabItems" :key="item.name">
        {{ item.name }}
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item v-for="item in tabItems" :key="item.name">
        <v-card v-if="item.name === 'User Logins Report'" flat>
          <UserMaintenanceReport />
        </v-card>
        <v-card v-if="item.name === 'User Impersonations'" flat>
          <UserImpersonationReport />
        </v-card>
        <!--<v-card v-if="item.name === 'User Document Report'" flat> 
            <UserDocumentReport />
          </v-card> -->
        <v-card v-if="item.name === 'ATS Export Report'" flat>
          <ATSExportReport />
        </v-card>
        <v-card v-if="item.name === 'Intake Flow Report'" flat>
          <IntakeReport />
        </v-card>
        <v-card v-if="item.name === 'Integration Logs'" flat>
          <IntegrationLogs :qaActions="qaActions" @openDocument="$emit('openDocument', $event)" />
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import UserMaintenanceReport from "../components/cUserMaintenanceReport.vue";
import UserImpersonationReport from "../components/cUserImpersonationReport.vue";
//import UserDocumentReport from '../components/cUserDocumentReport.vue'
import IntakeReport from "./cIntakeReport.vue";
import ATSExportReport from "./cATSReport.vue";
import IntegrationLogs from "./cIntegrationLogs.vue";
import { mapState } from "vuex";

export default {
  name: "reportHolder",
  props: {
    qaActions: { type: Array, required: true },
  },
  data: function () {
    return {
      tab: 0,
      reports: [
        { name: "User Logins Report", text: "" },
        { name: "User Impersonations", text: "" },
        { name: "ATS Export Report", text: "" },
        { name: "Intake Flow Report", text: "" },
        { name: "Integration Logs", text: "" },
      ],
      clientReports: [],
      adminReports: [],
    };
  },
  computed: {
    tabItems() {
      if (!this.configLoaded) return [];

      const enabledReports = this.$loginState.canAdmin ? this.adminReports : this.clientReports;
      return enabledReports
        .map(r => this.reports.find(rep => rep.name === r))
        .filter(rep => rep);
    },
    ...mapState({
      configLoaded: (state) => state.settings.initialised && !state.settings.loading,
      config: (state) => state.settings.config,
    }),
  },
  mounted() {
    if (this.configLoaded) {
      this.init();
    }
  },
  watch: {
    configLoaded(newVal) {
      if (newVal) {
        this.init();
      }
    },
  },
  created: function () { },
  components: {
    UserMaintenanceReport,
    UserImpersonationReport,
    //UserDocumentReport,
    ATSExportReport,
    IntakeReport,
    IntegrationLogs,
  },
  methods: {
    init() {
      const clientReportsSetting = this.config.settings.find((s) => s.setting === "client_usage_reports")?.value;
      if (clientReportsSetting)
        this.clientReports = clientReportsSetting.split("|");
      else
        this.clientReports = [
          "User Logins Report",
          "ATS Export Report",
          "Intake Flow Report",
        ];

      const adminReportsSetting = this.config.settings.find((s) => s.setting === "admin_usage_reports")?.value;
      if (adminReportsSetting)
        this.adminReports = adminReportsSetting.split("|");
      else
        this.adminReports = [
          "User Logins Report",
          "User Impersonations",
          "ATS Export Report",
          "Intake Flow Report",
        ];

      if (this.$route.params.reportName) {
        const reportName = this.$route.params.reportName.replace(' ', '');
        let reportTab = this.tabItems.findIndex(
          (tab) => tab.name.replace(' ', '') === reportName
        );
        if (reportTab >= 0) {
          this.$nextTick(() => {
            this.tab = reportTab;
          });
        }
      }
    }
  },
};
</script>